const state = {
    event: [],
    eventid: [],
    loading: false
};

export default state;